import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const EcomCompanyNameWUT = props => {
  const fieldType = FIELD_TYPES.ECOM_COMPANY_NAME;
  const addressCompanyNameLabel = useAddressLabel('company');
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: addressCompanyNameLabel
  }));
};
//# sourceMappingURL=ecom-company-name-wut.js.map